import { IntersectionIcon } from 'morpheus-ui';
import { Icon } from '../../atoms/Icon';
import InlineSvgIcon from '../../atoms/InlineSvgIcon';
import { Typography } from '../../molecules/Typography';
import { ProgressBar } from '../../atoms/ProgressBar';
import { Card, IconVariant, TextVariant } from './variants';
import { VariantProps } from 'tailwind-variants';
import { getDisciplineIcon } from '../../../utils/discipline';

interface IIconCard extends VariantProps<typeof Card> {
  title: string;
  description: string;
  subjects: number;
  action?: () => void;
  isHoverable?: 'white';
  slug: string;
  iconSVG?: string;
  progress?: number;
}

export default function IconCard({
  isHoverable = 'white',
  type,
  title,
  description,
  subjects,
  color,
  slug,
  iconSVG,
  action,
  progress,
}: IIconCard) {
  // Conteúdo do Universitário sempre usa o ícone fixo da disciplina (igual ao
  // menu), ignorando o `iconSVG` por módulo vindo da API — mesmo comportamento
  // do repositório irmão aprova-universitario.
  const isUniversitarioDiscipline = slug?.endsWith('-superior');

  // O slug de rota 'fisiologia-superior' usa o token de cor
  // 'disciplina-fisiologia-humana-superior' (mesmo alias do aprova-universitario).
  const progressBarColor =
    color === 'fisiologia-superior' ? 'fisiologia-humana-superior' : color;

  return (
    <div className={Card({ color })} onClick={() => action && action()}>
      {iconSVG && !isUniversitarioDiscipline ? (
        <InlineSvgIcon
          svg={iconSVG}
          className={IconVariant({ color, type })}
        />
      ) : (
        <Icon
          type='svg'
          Icon={getDisciplineIcon(slug) || IntersectionIcon}
          className={IconVariant({ color, type })}
        />
      )}
      <div className='flex justify-normal'>
        <Typography
          size='h3'
          type='title'
          className={`text-center md:line-clamp-2 ${TextVariant({ type: 'title', hover: isHoverable })}`}
        >
          {title}
        </Typography>
      </div>
      <div className='mt-auto'>
        <Typography
          className={TextVariant({ type: 'title', hover: isHoverable })}
        >
          {description}
        </Typography>
      </div>
      <Typography
        weight='bold'
        className={TextVariant({ type: 'paragraph', hover: isHoverable })}
      >
        {subjects} {subjects > 1 ? 'Assuntos' : 'Assunto'}
      </Typography>
      {progress !== undefined && (
        <div className='w-full flex flex-col gap-xs'>
          <ProgressBar
            progress={progress}
            color={progressBarColor ? `disciplina-${progressBarColor}` : undefined}
            backgroundColor='mono-color-lightest'
            height='3px'
            className='shadow-level-1 ring-1 ring-mono-color-black/5'
          />
          <Typography
            size='small'
            className={TextVariant({ type: 'paragraph', hover: isHoverable })}
          >
            {Math.round(progress)}% concluído
          </Typography>
        </div>
      )}
    </div>
  );
}
